var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Section } from '../../shared';
import { services } from '../../../shared';
import { CASE } from '../../../config/routes';
import { DeclarationsTable } from '../../sections/declarations/declarations-table/declarations-table';
import { SectionMenu } from '../../sections/question-sets/section-menu/section-menu';
export var DeclarationsPage = function (_a) {
    var _b, _c, _d;
    var location = _a.location;
    var _e = useParams(), caseId = _e.caseId, loanPurposeId = _e.loanPurposeId;
    var _f = useState([]), workflowSteps = _f[0], setWorkflowSteps = _f[1];
    var _g = useState([]), pages = _g[0], setPages = _g[1];
    var _h = useState(), setWorkflowStep = _h[1];
    var _j = useState(), formId = _j[0], setFormId = _j[1];
    var _k = useState(false), toggleMenuVisibility = _k[1];
    var fetchApplicationProgressBarSteps = function (caseId, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var applicationWorkflow, currentStep;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getDynamicWorkflow(caseId, loanPurposeId)];
                case 1:
                    applicationWorkflow = (_a.sent()).data;
                    setWorkflowSteps(applicationWorkflow.workflowSteps);
                    currentStep = applicationWorkflow.workflowSteps[applicationWorkflow.workflowSteps.length - 1];
                    setWorkflowStep(currentStep);
                    return [2 /*return*/, currentStep];
            }
        });
    }); };
    var fetchPageWithStatus = function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var pageWithStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getPagesWithStatus(caseId, formId)];
                case 1:
                    pageWithStatus = (_a.sent()).data;
                    setPages(pageWithStatus);
                    setFormId(formId);
                    return [2 /*return*/, pageWithStatus[0].sections[0].id];
            }
        });
    }); };
    var fetchCaseDetails = function (id, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var c, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((_b = location.state.case) !== null && _b !== void 0)) return [3 /*break*/, 1];
                    _a = _b;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, services.getCase(id)];
                case 2:
                    _a = (_c.sent()).data;
                    _c.label = 3;
                case 3:
                    c = _a;
                    location = {
                        state: {
                            applicants: c.applicants,
                            case: c,
                            loanPurposeId: loanPurposeId,
                        },
                    };
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id, loanPurpose, applicationProgressBarSteps;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = Number(caseId);
                    loanPurpose = Number(loanPurposeId);
                    return [4 /*yield*/, fetchApplicationProgressBarSteps(id, loanPurpose)];
                case 1:
                    applicationProgressBarSteps = _a.sent();
                    return [4 /*yield*/, fetchPageWithStatus(id, applicationProgressBarSteps.formId)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, fetchCaseDetails(id, loanPurpose)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        location.state = (_a = location.state) !== null && _a !== void 0 ? _a : {
            applicants: [],
            case: null,
            loanPurposeId: Number(loanPurposeId),
        };
        fetchData();
    }, [caseId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null),
        React.createElement(Section, null,
            React.createElement("div", { className: "l-grid" },
                React.createElement("div", { className: "l-grid_span-12 l-grid_span-4@bp20" },
                    React.createElement(SectionMenu, { pages: pages, rootPath: "".concat(CASE.paths[0], "/").concat((_d = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : caseId, "/"), location: location, workflowName: 'Declarations', closeMenu: toggleMenuVisibility })),
                React.createElement("div", { className: "l-grid_span-12 l-grid_span-8@bp20" },
                    React.createElement(DeclarationsTable, { pages: pages, steps: workflowSteps, location: location, formId: formId, caseId: Number(caseId) }))))));
};
